import * as React from "react";
import { PropertyFiltersComponentProps } from "../typings";
import { UitkRadio } from "uitk-react-switch";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { withStores } from "src/stores";
import { observer } from "mobx-react";
import { UitkSpacing } from "uitk-react-spacing";

const RadioButtonTracked = FlexClickTracker(UitkRadio);

export const Radio = withStores("propertyFilters")(
  observer((props: PropertyFiltersComponentProps) => {
    const { filterName, option, propertyFilters, moduleName } = props;
    const { optionValue, description, label } = option;

    const onChange = () => {
      propertyFilters.toggleSelection(filterName, optionValue ?? "");
    };

    const isSelected = propertyFilters.isSelected(filterName, optionValue ?? "");

    return (
      <UitkSpacing margin="half">
        <RadioButtonTracked
          events="click"
          id={`${filterName}-${optionValue}`}
          moduleName={moduleName}
          rfrr={`${moduleName}.${filterName}.${optionValue}.${!isSelected}`}
          value={optionValue}
          checked={isSelected}
          onChange={onChange}
          description={description}
          autoComplete="off"
        >
          {label}
        </RadioButtonTracked>
      </UitkSpacing>
    );
  })
);
